import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const HouseholdOnboardingDetailSheetAccountsQuery = graphql(/* GraphQL */ `
  query HouseholdOnboardingDetailSheetAccounts($id: ID!) {
    advisorOnboardingStagedHousehold(id: $id) {
      id
      uuid
      onboardingAccounts {
        id
        number
        accountName
        accountType
        custodian
      }
    }
  }
`);

export type HouseholdOnboardingDetailSheetAccounts = NonNullable<
  ResultOf<typeof HouseholdOnboardingDetailSheetAccountsQuery>['advisorOnboardingStagedHousehold']
>;

export type HouseholdOnboardingDetailSheetAccount =
  HouseholdOnboardingDetailSheetAccounts['onboardingAccounts'][number];
